/**
 * Mando UI initialisation
 */

/* eslint-disable */
import Vue from "NodeModules/vue/dist/vue.min.js";

// Simple observable event bus to allow communication between components
Vue.prototype.$eventBus = new Vue();

import moment from "NodeModules/moment/moment";
import polyfillClosest from "../polyfill";
import header from "Components/developers/header/header";
import navigationOffCanvas from "Components/developers/navigation/navigation-off-canvas";
import navigationDropdown from "Components/developers/navigation-dropdown/navigation-dropdown";
import search from "Components/developers/search/search";
import accordion from "Components/developers/accordion/mando-ui.accordion";
import videoHero from "Components/developers/hero/mando-ui.video-hero";
import tabs from "Components/developers/tabs/mando-ui.tabs";
import cardCarousel from "Components/developers/card-carousel/card-carousel";
import notify from "Components/developers/notify/notify";
import videoPlayer from "Components/developers/video/video";
import person from "Components/developers/person/person";
import waterCalculator from "Components/developers/water-calculator/water-calculator";

import searchResults from "Components/developers/results/SearchResults.vue";
import childPageCtas from "Components/developers/child-page-ctas/ChildPageCtas.vue";

document.addEventListener("DOMContentLoaded", () => {
  // Add JS helper class
  document.getElementsByTagName("html")[0].classList.remove("no-js");
  document.getElementsByTagName("html")[0].classList.add("has-js");

  //* Polyfill
  polyfillClosest();
  // Components
  header();
  navigationOffCanvas();
  navigationDropdown();
  search();
  accordion();
  videoHero();
  tabs();
  cardCarousel();
  notify();
  videoPlayer();
  person();
  waterCalculator();
  
  const searchResultsEl = document.querySelector("#search-results");
  const childPageCtasEls = document.querySelectorAll(".child-page-ctas");

  Vue.filter("formatDate", (value) => {
    if (!value) {
      return "";
    }
    return moment(value).format("DD/MM/YY");
  });

  Vue.filter("formatFileSize", (value) => {
    return `${(value / Math.pow(1024, 1)).toFixed(2)}kB`;
  });

  Vue.filter("booleanToYesNo", (value) => (value ? "Yes" : "No"));

  if (searchResultsEl) {
    /* eslint-disable no-new */
    new Vue({
      el: "#search-results",
      render: (h) =>
        h(searchResults, {
          props: {
            searchLabel: searchResultsEl.dataset.searchLabel,
            searchDescription: searchResultsEl.dataset.searchDescription,
            sites: JSON.parse(searchResultsEl.dataset.sites)
          },
        }),
    });
    /* eslint-enable */
  }

  if (childPageCtasEls.length) {
    /* eslint-disable no-new */
    childPageCtasEls.forEach(
      (childPageCtasEl) =>
        new Vue({
          el: ".child-page-ctas",
          render: (h) =>
            h(childPageCtas, {
              props: {
                componentId: childPageCtasEl.dataset.componentId,
                pageId: childPageCtasEl.dataset.pageId,
                options: JSON.parse(childPageCtasEl.dataset.options),
                theme: childPageCtasEl.dataset.theme,
              },
            }),
        })
    );

    /* eslint-enable */
  }
});



// WEBPACK FOOTER //
// ./src/scripts/brands/developers.js